import { Pipe, PipeTransform } from '@angular/core';

import {
  colorMapping,
  EppColorMappingPerParameterset,
  EppColorMappingResult,
  EppColorMappings,
} from 'src/app/constants/constants';

@Pipe({ name: 'colorMapping' })
export class ColorMappingPipe implements PipeTransform {
  transform(
    parameterset: string,
    parameter: string,
    value: number,
    greenTableDesign: boolean,
    colorMappingPerParameterset: EppColorMappingPerParameterset,
    colorMappings: EppColorMappings
  ): EppColorMappingResult {
    return colorMapping(
      parameterset,
      parameter,
      value,
      greenTableDesign,
      colorMappingPerParameterset,
      colorMappings
    );
  }
}
